<template>
  <div class="w-root">
    <UpgradeToProModal @hideModal="showUpgradeModal = false" v-if="showUpgradeModal"></UpgradeToProModal>
    <UpgradeToProVisitModal @hideModal="showUpgradeVisitModal = false" v-if="showUpgradeVisitModal"></UpgradeToProVisitModal>
    <div class="w-views">
      <div class="secondary-menu profile" v-if="user_loaded && user && !user.deleted_at && user.status !== 'deactivated'" :class="{'report-menu-open': reportMenuVisible}">
        <div class="secondary-menu-body">
          <div class="secondary-menu-header">
            <i class="back" v-on:click="goBackToUser"></i>
            <div @click="copyHandle" class="info"
                 :class="{'online': user.isOnline, 'was-online': user.wasRecentlyOnline && !user.isOnline}">
              <div class="name notranslate">{{ user.headline }}</div>
              <div class="link-group">
                <div  class="link notranslate">@{{ user.handle }}</div>
                <div class="verified-icon" v-if="user.verified"></div>
              </div>
              <div class="how-far notranslate" v-if="!isSelfUser">{{ getDistanceString(user) }}</div>
            </div>
            <alert v-if="link_copied_alert" :small="true" v-on:hide-alert="hideAlert">
              {{ trans('link_copied') }}
            </alert>
            <i class="notes" v-if="!isSelfUser" :class="{'active' : user.note !== null}" @click="toggleNoteModal()"></i>
            <i class="dots" v-if="!isSelfUser && app.$store.state.profile.id" @click="menuVisible = !menuVisible"></i>
            <div class="block-report" :class="{'open': menuVisible}">
              <div id="block-profile" class="option block"
                   v-show="!reportMenuVisible" v-on:click="blockUser">
                <span>{{ trans('block_user') }}</span>
              </div>
              <div id="report-profile" class="option report"
                   v-show="!reportMenuVisible" v-on:click="showReportMenu">
                <span>{{ trans('report_user') }}</span>
              </div>
            </div>
            <UserNotes v-if="!isSelfUser" @hideModal="showNotesModal = false" :noteString="user.note ? user.note.note : ''" :user_id="user.id" :active="showNotesModal"></UserNotes>
          </div>

          <vue2-gesture-custom :type="'swipeRight'" :call="handleGesture.bind(this, 'swipeRight')">
            <div class="main-box">
              <div class="photo" id="js-user-image"
                   :style="{'background': `url(${user.photo_orig}) no-repeat center / cover`}"
                   @click="goToPhoto(avatar)">
              </div>

            <div class="main-box-footer" :class="{'justify-end': discreetMode}">
              <router-link v-if="isSelfUser" class="edit-button btn" :to="`/profile/edit`">
                <span>{{ 'Edit' || trans('edit_profile') }}</span>
              </router-link>
              <div class="hide-visit-button" @click="toggleHideVisit" :class="{'active' : hideVisitButtonActive}" v-if="!isSelfUser && !discreetMode"></div>
              <div class="func-buttons" v-if="!isSelfUser">
                <div id="to-favorite" class="button to-favorite"
                     v-on:click="toggleFavorite(user)"
                     :class="{'selected': user.isFavorite}">
                </div>
                <div id="to-tap" class="button to-tap" :class="{'tapsForPro': userIsPro, 'open': toggleTapVisible}" v-on:click="toggleTapVisible">
                  <div v-if="waveIcon" class="tap-icon-given" :style="{'background-image': 'url('+ waveIcon +')'}"></div>
                  <div v-else class="to-tap-icon"></div>
                  <transition name="scale-in-center">
                    <div class="taps" v-show="tapsVisible">
<!--                      <div class="tap video" v-if="userIsPro"-->
<!--                           v-on:click="waveToUser(userId, 'video', $event)">-->
<!--                      </div>-->

                      <div class="tap donut" v-if="userIsPro"
                           v-on:click="waveToUser(userId, 'donut', $event)">
                      </div>

                      <div class="tap rocket" v-if="userIsPro"
                           v-on:click="waveToUser(userId, 'rocket', $event)">
                      </div>
                      <div class="tap beer" v-if="userIsPro"
                           v-on:click="waveToUser(userId, 'beer', $event)">
                      </div>
<!--                      <div class="tap ring" v-if="userIsPro"-->
<!--                           v-on:click="waveToUser(userId, 'ring', $event)">-->
<!--                      </div>-->

                      <div class="tap nicebody" v-if="userIsPro"
                           v-on:click="waveToUser(userId, 'nicebody', $event)">
                      </div>

                      <div class="tap now" v-on:click="waveToUser(userId, 'now', $event)"></div>
<!--                      <div class="tap sweat" v-on:click="waveToUser(userId, 'sweat', $event)"></div>-->
                      <div class="tap pig" v-on:click="waveToUser(userId, 'pig', $event)"></div>
                      <div class="tap devil" v-on:click="waveToUser(userId, 'devil', $event)"></div>

                      <div class="tap apple" v-on:click="waveToUser(userId, 'apple', $event)"></div>
                      <div class="tap love" v-on:click="waveToUser(userId, 'love', $event)"></div>
                      <div class="tap banana" v-on:click="waveToUser(userId, 'banana', $event)"></div>
                      <div class="tap fire" v-on:click="waveToUser(userId, 'fire', $event)"></div>
                      <div class="tap hand" v-on:click="waveToUser(userId, 'hand', $event)"></div>
                    </div>
                  </transition>
                </div>
                <div id="to-chat" class="button to-chat"
                     v-on:click="chatUser" :class="{'notificated': user.unreadMessagesCount > 0}">
                </div>
              </div>
            </div>
          </div>
          <div class="profile-footer"
               v-if="user.tiktok_link || user.x_link || user.instagram_link || user.jff_link || user.about || user.height || user.weight || user.body || user.position || user.penis || user.hiv || onlyPublicPhotos && onlyPublicPhotos.length || videos && videos.length">
            <div class="box">
              <div @click="clickAbout" class="about" v-if="user.about">
                <p v-html="getMsgTextWithLinks(user.about,user.about_links)"></p>
              </div>
              <div class="tags" v-if="!isApp && user.tags && user.tags.length">
                <div class="tag notranslate" v-for="tag in user.tags">
                  <a @click.prevent="goSearchTag(tag);" :href="'/search?q='+encodeURIComponent('#'+tag.name)">{{ tag.name }}</a>
                </div>
              </div>
              <div class="parameters-box"
                   v-if="user.age || user.height || user.weight || user.body || user.position || user.penis || user.hiv">
                <div class="parameters" v-if="user.age || user.height || user.weight || user.body">
                  <span v-if="user.age">{{ user.age }}</span>
                  <span v-if="user.height">{{ formatHeight(user.height) }}</span>
                  <span v-if="user.weight">{{ formatWeight(user.weight) }}</span>
                  <span v-if="user.body">{{ transBody(user.body).toLowerCase() }}</span>
                </div>
                <div class="parameters" v-if="user.position || user.penis">
                  <span v-if="user.position">{{ transPosition(user.position).toLowerCase() }}</span>
                  <span v-if="user.penis">{{ user.penis }}</span>
                </div>
                <div class="parameters" v-if="user.hiv">
                  <span>{{ trans('hiv') }}: {{ transHiv(user.hiv).toLowerCase() }}</span>
                </div>
                <div class="parameters" v-if="user.drugs">
<!--                  <span>{{ trans('drugs') }}: {{ transDrugs(user.drugs).toLowerCase() }}</span>-->
                </div>
              </div>
            </div>
            <div class="pics-catalog" v-if="onlyPublicPhotos && onlyPublicPhotos.length">
              <div class="pic" v-for="photo in onlyPublicPhotos"
                   :class="{'sensitive': photo.manual_rating === 'prohibited'}"
                   :id="`photo${photo.id}`"
                   @click="goToPhoto(photo)">
                <div class="img" :id="'photo' + photo.id"
                     :style="{'background': `url(${photo.photo_small}) no-repeat center / cover`}">
                </div>
              </div>
            </div>
            <div class="pics-catalog" v-if="videos && videos.length">
              <div class="pic video" v-for="video in videos"
                   :id="`video${video.id}`"
                   @click="goToVideo(video)">
                <div class="img" :id="'video' + video.id"
                     :style="{'background': `url(${video.thumb_small}) center / cover`}">
                </div>
              </div>
            </div>
            <div v-if="user.tiktok_link || user.x_link || user.instagram_link || user.jff_link || buddyLinksReverse.length > 0" class="follow-links">
                <div class="follow-links-social">
                  <div class="follow-links-social-headline">{{ trans('follow') }}:</div>
                  <div class="follow-links-social-list">
                    <a target="_blank" :href="user[social_link]" v-if="user[social_link]" v-for="social_link in ['jff_link','instagram_link','x_link','tiktok_link']" class="follow-links-social-list-row">
                        <span :class="'follow-links-social-list-row-' + social_link"></span>
                    </a>
                  </div>
                </div>
              <div class="follow-links-buddy_links box buddy-links" v-if="buddyLinksReverse.length > 0">
                <div class="buddy-links-list">
                  <div class="buddy-links-list-row" v-for="buddy_link in buddyLinksReverse">
                    <div class="buddy-links-list-row-img" @click="clickBuddyLink" :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" :style="{'background-image':'url('+buddy_link.photo_small+')'}"></div>
                    <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details"  @click="clickBuddyLink">
                      <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-headline">{{buddy_link.headline}}</div>
                      <div :data-issue-type="buddy_link.event_type" :data-issue="buddy_link.issue_type" :data-issue-id="buddy_link.issue_id" class="buddy-links-list-row-details-handle">@{{buddy_link.handle}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          </vue2-gesture-custom>
        </div>

        <div class="mobileSidebarHolder positionRight"
             v-show="showReportMenu"
             :class="{'active': reportMenuVisible}">
          <div class="mobileSidebarHide" @click="hideReportMenu"></div>
          <div class="mobileSidebar">

            <div class="report-menu">
              <div class="inner">
                <div class="title">{{ trans('report_user') }}</div>
                <div class="box">
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" name="spam" value="spam" v-model="reportData">
                      <span class="checkbox-custom"></span>
                      <div class="input-title">{{ trans('report_spam') }}</div>
                    </label>
                  </div>
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" name="fake" value="fake" v-model="reportData">
                      <span class="checkbox-custom"></span>
                      <div class="input-title">{{ trans('report_fake') }}</div>
                    </label>
                  </div>
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" name="harassment" value="harassment" v-model="reportData">
                      <span class="checkbox-custom"></span>
                      <div class="input-title">{{ trans('report_harassment') }}</div>
                    </label>
                  </div>
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" name="under-age" value="under_age" v-model="reportData">
                      <span class="checkbox-custom"></span>
                      <div class="input-title">{{ trans('report_under_age') }}</div>
                    </label>
                  </div>
                  <div class="checkbox-container">
                    <label class="checkbox-label">
                      <input type="checkbox" name="other" value="other" v-model="reportData">
                      <span class="checkbox-custom"></span>
                      <div class="input-title">{{ trans('report_other') }}</div>
                    </label>
                  </div>
                </div>
                <button type="send" class="btn" @click="reportUser">{{ trans('send') }}</button>
              </div>
            </div><!--report-menu-->

          </div>
        </div>

      </div>
      <div v-else >
        <div v-if="user_loaded" class="secondary-menu profile">
          <div class="secondary-menu-body">
            <div class="secondary-menu-header">
              <i class="back" v-on:click="goBackToUser"></i>
            </div>
            <div class="main-box">
              <div class="user-error-message">
                <span v-if="!user">
                  {{ trans('user_not_found') }}
                </span>
                <div v-else>
                   <span v-if="user.deleted_at">
                    {{ trans('profile_is_deleted') }}
                  </span>
                  <span v-if="user.status == 'deactivated'">
                    {{ trans('profile_is_deactivated') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--w-views-->
  </div><!--w-root-->
</template>

<script>
import {mapState, mapGetters} from 'vuex';

import Alert from '@buddy/views/widgets/Alert.vue';
import chatModule from "@chat/module/store/type";
import notificationsModule from "@notifications/module/store/type";
import UserNotes from "../../widgets/UserNotes.vue";
import UpgradeToProModal from "../../widgets/UpgradeToProModal.vue";
import UpgradeToProVisitModal from "../../widgets/UpgradeToProVisitModal.vue";

export default {
  components: {Alert, Map, UpgradeToProVisitModal, UpgradeToProModal, UserNotes},
  data() {
    return {
      app: app,
      tapsVisible: false,
      pid: 0,
      link_copied_alert:false,
      hideVisitButtonActive: false,
      hideLinkPopUpTimeout:false,
      reportData: [],
      showNotesModal: false,
      menuVisible: false,
      reportMenuVisible: false,
      showUpgradeVisitModal: false,
      showUpgradeModal: false,

      user_loaded : false,
    }
  },
  mixins: [
    require('@general/lib/mixin').default,
    require('@general/lib/mixin-tap').default,
    require('@general/lib/mixin-clubs').default,
    require('@general/lib/mixin-events').default,
  ],
  props: ['userToken'],
  methods: {
    handleGesture(str, e) {
      if (str == 'swipeRight') {
        this.goBackToUser();
      }
    },
    copyHandle(){
      this.link_copied_alert = true
      navigator.clipboard.writeText('@' + this.user.handle).then(function() {
        console.log('Async: Copying to clipboard was successful!');
      }, function(err) {
        console.error('Async: Could not copy text: ', err);
      });
    },
    hideAlert(){
      this.link_copied_alert = false;
    },
    clickAbout(e){
      if(e.target.classList.contains('issue_link')){
        this.openLink(e);
      }
    },
    toggleHideVisit(){
      if(this.showJoinModalIfNeed()){
        return false;
      }
      if(this.userIsPro){
        this.hideVisitButtonActive = !this.hideVisitButtonActive
      }else{
        this.showUpgradeVisitModal = true;
      }
    },
    toggleNoteModal(){
      if(this.showJoinModalIfNeed()){
        return false;
      }
      if(this.userIsPro){
        this.showNotesModal = !this.showNotesModal;
      }else{
        this.showUpgradeModal = true;
      }
    },
    closeUserModalWithVisit(){
      window.onpopstate = false;
      if(!this.hideVisitButtonActive){
        this.$store.dispatch(notificationsModule.actions.addVisit, { userId: this.user.id });
      }
      this.hideVisitButtonActive = false;

      this.showNotesModal = false;
      let self = this;
      setTimeout(function (){
        self.closeUserModal();
      },200)
    },
    goBackToUser() {
      this.closeUserModalWithVisit();
      if (window.history.length > 1) {
          this.$router.go(-1);
      } else {
          this.goBack('/search', user.id)
      }
    },
    goSearchTag(tag) {
      this.closeUserModalWithVisit();
      this.$router.replace({ name: 'search', query: { q: '#'+tag.name  }, })
    },
    redirectToDiscover() {
      this.$nextTick(() => {
        this.openUserModal(this.$route.params.userToken, 3);
        this.$router.push({path: '/discover'});
      })
    },
    addWaveToUser(recipientId, type) {
      this.tapsVisible = !this.tapsVisible;
      this.waveToUser(recipientId, type);
    },
    chatUser() {
      if(app.$store.state.profile.email_verify_required && !app.$store.state.profile.email_verified && this.user.id !== 100001){
        this.showVerifyEmailModal();
        return false;
      }
      if(this.showJoinModalIfNeed()){
        return false;
      }
      let userToken = this.user.handle || this.user.id
      this.goToOrBack('/chat/' + userToken + '/' + this.user.conversation_id);
    },
    async blockUser() {
      if (!this.$store.state.userIsPro && this.$store.state.blockedCount >= window.FREE_BLOCKS_LIMIT) {
        await this.$store.dispatch('requirementsAlertShow', 'blocks')
      } else {
        await this.blockUserById(this.userId)
        this.goTo('/discover');
      }
    },
    showReportMenu() {
      this.reportMenuVisible = true;
    },
    hideReportMenu() {
      this.reportMenuVisible = false;
    },
    hideMenu() {
      this.hideReportMenu()
      this.menuVisible = false
    },
    reportUser() {
      app.showLightLoading(true);
      axios.post(`/api/reportUser/${this.userId}?type=${this.reportData}`)
          .then(() => {
            app.showLightLoading(false);
            this.showSuccessNotification('user_reported_confirmation');
            this.closeFilter();
          });
    },
    closeFilter() {
      this.hideReportMenu();
    },
    clickBuddyLink(e){
      this.openLink(e);
    },
    goToPhoto(photo) {
      /* too_hot */
      let isSafe = this.photoIsSafe(photo)
      if (!isSafe) {
        return
      }

      if (photo !== undefined) {
        let userToken = this.user.handle || this.user.id
        this.$router.push(`/user/${userToken}/photo/${photo.id}`)
      }
    },
    goToVideo(video) {
      /* too_hot */
      if (video && this.isApp && (!app.$store.state.userIsPro || app.$store.state.profile.app_view_sensitive_media == 'no')) {
        if (!app.$store.state.userIsPro) app.$store.dispatch('requirementsAlertShow', 'censored')
        else app.$store.dispatch('requirementsAlertShow', 'change_settings')
      } else if (video !== undefined) {
        let userToken = this.user.handle || this.user.id
        this.$router.push(`/user/${userToken}/video/${video.id}`)
      }
    },
    // loadSwiperScript() {
    //   if (this.publicPhotos.length > 1) {
    //     this.pid = this.photo ? this.photo.id : 0
    //     this.loadSwiper(0, this.onPhotoChanged)
    //   }
    // },
    // onPhotoChanged(newIndex) {
    //   this.pid = this.publicPhotos[newIndex].id
    // },
  },
  computed: {
    ...mapState({
      userIsPro: 'userIsPro',
      discreetMode: 'discreetMode',
      blockedUsersIds: 'blockedUsersIds',
    }),
    ...mapGetters({
      unreadMessagesCount: chatModule.getters.messages.count.unread
    }),
    buddyLinksReverse(){
      return [].concat(this.user.buddy_links).reverse();
    },
    userId() {
      return this.user ? this.user.id : null
    },
    user() {
      return this.$store.getters.getUser(this.userToken)
    },
    photos() {
      return this.user && this.user.public_photos;
    },
    photo() {
      return this.publicPhotos && this.publicPhotos.find(el => el.id == this.pid);
    },
    publicPhotos() {
      if (this.isApp && (!app.$store.state.userIsPro || app.$store.state.profile.app_view_sensitive_media == 'no')) {
        return this.user && this.user.public_photos.filter(v => ((!v.aws_nudity_rating || v.aws_nudity_rating <= window.START_NUDITY_RATING) && v.nudity_rating <= window.START_NUDITY_RATING) || v.is_default == 'yes')
      } else {
        return this.user && this.user.public_photos;
      }
    },
    photoPosition() {
      return this.publicPhotos && this.publicPhotos.indexOf(this.photo) + 1;
    },
    videos() {
      return this.user && this.user.public_videos;
    },
    onlyPublicPhotos() {
      let self = this;
      return this.photos.filter(function (v){
        return v.id !== self.user.photo_id && (v.manual_rating !== 'unrated'|| (v.manual_rating === 'unrated' && v.nudity_rating < window.NUDITY_RATING));
      });
    },
    avatar() {
      return this.photos.find(v => v.is_default == 'yes');
    }
  },
  watch: {
    link_copied_alert: function (val) {
      if(val){
        let self= this;
        this.hideLinkPopUpTimeout = setTimeout(function (){
          self.link_copied_alert = false;
        },2500)
      }else{
        if(this.hideLinkPopUpTimeout){
          clearTimeout(this.hideLinkPopUpTimeout);
        }
      }
    },
    blockedUsersIds: function(blockedUsersIds) {
      if (blockedUsersIds.includes(this.user?.id)) {
        this.goTo('/discover')
      }
    }
  },
  activated(){
    let self = this;
    //add visit on closing user page
    window.onpopstate = function() {
      self.closeUserModalWithVisit();
    };
  },
  mounted() {
    // if (this.user) {
    //   this.loadSwiperScript()
    // }
    if (!!this.userToken && !this.user) {
      this.$store.dispatch('loadUserInfo', this.userToken).then(() => {
        this.user_loaded = true;
      })
    }else{
      this.user_loaded = true;
    }
  },
  beforeCreated() {
    if (app.isDesktop) {
      this.redirectToDiscover();
    }
  },
  beforeMount() {
    if (app.isDesktop) {
      this.redirectToDiscover();
    }
  }
}
</script>
